
$(document).on('click', '.cs-question-link', function(e){
    $(this).closest('li').find('.pub-answers').toggle();
    e.stopImmediatePropagation();
    return false;
});

